class LMPAccount {
    loginSessionID: string | undefined;
    userID: string;
    userIDType: string;
    userNo: string | undefined;
    dateOfBirth: string;
    country: string;
    countryName: string;
    blacklist: "Y" | "N" | undefined;
    age: string;
    isSubscribe: "Y" | "N";
    periodPW: "Y" | "N" | undefined;
    displayUserID: string;
    instllrFlag: "Y" | "N";

    constructor({
        loginSessionID,
        userID,
        userIDType,
        userNo,
        dateOfBirth,
        country,
        countryName,
        blacklist,
        age,
        isSubscribe,
        periodPW,
        displayUserID,
        instllrFlag,
    }: {
        loginSessionID?: string;
        userID: string;
        userIDType: string;
        userNo?: string;
        dateOfBirth: string;
        country: string;
        countryName: string;
        blacklist?: "Y" | "N";
        age: string;
        isSubscribe: "Y" | "N";
        periodPW?: "Y" | "N";
        displayUserID: string;
        instllrFlag: "Y" | "N";
    }) {
        this.loginSessionID = loginSessionID;
        this.userID = userID;
        this.userIDType = userIDType;
        this.userNo = userNo;
        this.dateOfBirth = dateOfBirth;
        this.country = country;
        this.countryName = countryName;
        this.blacklist = blacklist;
        this.age = age;
        this.isSubscribe = isSubscribe;
        this.periodPW = periodPW;
        this.displayUserID = displayUserID;
        this.instllrFlag = instllrFlag;
    }
}

export default LMPAccount;
